"use strict";

window.morningstar = window.morningstar || {};

window.morningstar.uim = window.morningstar.uim || {};

// Components
window.morningstar.uim.UimChangeEmailWidget = require("./js/change-email");

window.morningstar.uim.UimChangePasswordWidget = require("./js/change-password");

window.morningstar.uim.UimResetPasswordWidget = require("./js/reset-password");

window.morningstar.uim.UimConfirmPasswordWidget = require("./js/confirm-password");

window.morningstar.uim.UimUserProfileWidget = require("./js/user-profile");

window.morningstar.uim.UimLoginWidget = require("./js/login");

window.morningstar.uim.UimRegistrationWidget = require("./js/registration");

window.morningstar.uim.UimUserRegistrationWidget = require("./js/user-registration");

window.morningstar.uim.UimConsentFormWidget = require("./js/consent-form");

window.morningstar.uim.UimCDSSOWidget = require("./js/cdsso");



// Templates
window.templates = require("../build/Handlebars/Templates");

if (typeof window.templates === 'object' && window.templates !== null) {
    window.morningstar.uim.templates = templates.templates;
}



//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/index.js
// module id = 0
// module chunks = 0